import { render, staticRenderFns } from "./ahFileIcon.vue?vue&type=template&id=14010239&"
import script from "./ahFileIcon.vue?vue&type=script&lang=js&"
export * from "./ahFileIcon.vue?vue&type=script&lang=js&"
import style0 from "./ahFileIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports